import CurrencyInput from '../../../common/CurrencyInput';
import { CommonInputProps } from './DataInputField';

type DataInputMoneyProps = CommonInputProps & {
  currencySymbol: string;
};

export function DataInputMoney({
  inputValue,
  setInputValue,
  onSave,
  onKeyDown,
  variant,
  autoFocus,
  currencySymbol,
  ariaLabelledBy,
}: DataInputMoneyProps) {
  return (
    <CurrencyInput
      value={String(inputValue || '')}
      onChange={val => setInputValue(String(val || ''))}
      onKeyDown={onKeyDown}
      onBlur={onSave}
      leftSection={currencySymbol}
      variant={variant}
      autoFocus={autoFocus}
      styles={{ input: { width: '100px' } }}
      aria-labelledby={ariaLabelledBy}
    />
  );
}
